export const sxStyle = {
  divBookingDetail: {
    width: '100%',
    height: 'auto',
    border: { xs: '1px solid #E5E5E5', sm: '4px solid #E5E5E5' },
    bgcolor: '#FFFFFF',
    borderRadius: '8px',
  },

  gridContainerBookingDetail: {
    p: { xs: '10px', sm: '30px' },
  },

  bookingDetailTitle: {
    width: '100%',
    color: '#000',
    fontWeight: 700,
    fontSize: { xs: '14px', sm: '24px' },
    lineHeight: 1,
    pb: { xs: '5px' },
  },

  container: {
    display: 'flex',
    justifyContent: 'center',
  },

  grid: {
    mt: 4,
    py: { xs: 6, sm: 8 },
    width: { xs: '100% !important', sm: '98% !important' },
    minHeight: { xs: 'auto !important' },
    bgcolor: '#fff',
    borderRadius: { xs: '0px', sm: '8px' },
  },

  content: {
    textAlign: 'center',
    maxWidth: { xs: '100%', sm: '65%' },
  },

  badgeWrapper: {
    width: { xs: '64px', sm: '80px' },
    height: { xs: '64px', sm: '80px' },
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    mx: 'auto',
    mb: 1,
  },

  successBadgeBg: { bgcolor: '#e8f8ef' },
  deniedBadgeBg: { bgcolor: '#fdecea' },
  warningBadgeBg: { bgcolor: '#fff4e5' },
  reviewBadgeBg: { bgcolor: '#e3f2fd' },

  successIcon: {
    fontSize: { xs: '32px', sm: '40px' },
    color: '#1e8e4e',
  },

  errorIcon: {
    fontSize: { xs: '32px', sm: '40px' },
    color: '#c62828',
  },

  warningIcon: {
    fontSize: { xs: '32px', sm: '40px' },
    color: '#b45400',
  },

  reviewIcon: {
    fontSize: { xs: '32px', sm: '40px' },
    color: '#0277bd',
  },

  infoBox: {
    display: 'inline-block',
    bgcolor: '#f5f6f8',
    border: '1px solid #e3e5e9',
    borderRadius: '6px',
    px: 2,
    py: 1,
    mt: 1,
  },

  title: {
    color: 'text.primary',
    fontSize: { xs: '18px', sm: '22px' },
    fontWeight: 600,
    lineHeight: 1,
  },

  subtitle: {
    color: 'text.primary',
    fontSize: { xs: '14px', sm: '18px' },
    my: 1,
    whiteSpace: 'pre-line',
  },

  infoText: {
    fontWeight: 500,
    color: 'text.primary',
    fontSize: { xs: '14px', sm: '16px' },
  },

  highlightText: {
    fontWeight: 600,
    color: 'tertiary.main',
    fontSize: { xs: '14px', sm: '18px' },
    ml: 1,
  },

  infoSeparator: {
    color: 'text.disabled',
    mx: 1.5,
  },

  buttonPrimary: theme => ({
    mt: { xs: 1, sm: 2 },
    width: { xs: '60%', sm: '30%' },
    height: { xs: '35px', sm: '50px' },
    fontSize: { xs: '14px', sm: '18px' },
    fontWeight: 600,
    borderRadius: '8px',
    bgcolor: theme.primary,
    boxShadow: 'none',
    '&:hover': {
      bgcolor: theme.primary,
      color: theme.text1,
    },
  }),

  buttonOutline: theme => ({
    mt: { xs: 1, sm: 2 },
    width: { xs: '60%', sm: '30%' },
    height: { xs: '35px', sm: '50px' },
    fontSize: { xs: '14px', sm: '18px' },
    fontWeight: 600,
    borderRadius: '8px',
    color: theme.tertiary,
    borderColor: theme.tertiary,
    '&:hover': {
      borderColor: theme.tertiary,
      bgcolor: 'rgba(0, 0, 0, 0.04)',
    },
  }),
};
